import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';

export interface ErrorCSSStyle extends UIComponentCSSStyle
{
    
}

export class ErrorCSSStyleImpl extends UIComponentCSSStyleImpl implements ErrorCSSStyle
{   
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/navigation/error/errorcss.tsx